import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\AnalyticsController::resolve
* @see app/Http/Controllers/Admin/AnalyticsController.php:440
* @route '/app/analytics/gaps/{contentGap}/resolve'
*/
export const resolve = (args: { contentGap: string | { id: string } } | [contentGap: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

resolve.definition = {
    methods: ["post"],
    url: '/app/analytics/gaps/{contentGap}/resolve',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AnalyticsController::resolve
* @see app/Http/Controllers/Admin/AnalyticsController.php:440
* @route '/app/analytics/gaps/{contentGap}/resolve'
*/
resolve.url = (args: { contentGap: string | { id: string } } | [contentGap: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { contentGap: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { contentGap: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            contentGap: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        contentGap: typeof args.contentGap === 'object'
        ? args.contentGap.id
        : args.contentGap,
    }

    return resolve.definition.url
            .replace('{contentGap}', parsedArgs.contentGap.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AnalyticsController::resolve
* @see app/Http/Controllers/Admin/AnalyticsController.php:440
* @route '/app/analytics/gaps/{contentGap}/resolve'
*/
resolve.post = (args: { contentGap: string | { id: string } } | [contentGap: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AnalyticsController::resolve
* @see app/Http/Controllers/Admin/AnalyticsController.php:440
* @route '/app/analytics/gaps/{contentGap}/resolve'
*/
const resolveForm = (args: { contentGap: string | { id: string } } | [contentGap: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AnalyticsController::resolve
* @see app/Http/Controllers/Admin/AnalyticsController.php:440
* @route '/app/analytics/gaps/{contentGap}/resolve'
*/
resolveForm.post = (args: { contentGap: string | { id: string } } | [contentGap: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: resolve.url(args, options),
    method: 'post',
})

resolve.form = resolveForm

const gaps = {
    resolve: Object.assign(resolve, resolve),
}

export default gaps